import React, { Suspense } from 'react';
import { Button, Form, Select } from 'antd';
import { usePaymentAccountOptions } from '../../state/paymentAccounts';
import AutoSelectButton from '../AutoSelectButton';
import Loading from '~/App/components/Loading';
import ErrorBoundary from '~/App/ErrorBoundary';

type PaymentTabProps = {
  placeholder: string;
  onSubmit: (description: string) => void;
};

const PaymentTabForm = ({ placeholder, onSubmit }: PaymentTabProps) => {
  const [form] = Form.useForm();
  const options = usePaymentAccountOptions();
  const onFinish = ({ description }: any) => {
    onSubmit(description);
  };

  const onAutoSelect = (val: string) => {
    form.setFieldValue('description', val);
  };

  return (
    <Form form={form} onFinish={onFinish}>
      <div className="flex gap-2">
        <AutoSelectButton onSelect={onAutoSelect} />
        <div className="flex flex-1">
          <Form.Item
            name="description"
            rules={[{ required: true, message: 'Jenis harus dipilih' }]}
            style={{ width: '100%', flex: 1 }}
          >
            <Select
              size="large"
              options={options}
              placeholder={placeholder}
              style={{ width: '100%', flex: 1 }}
            />
          </Form.Item>
          <Form.Item>
            <Button htmlType="submit" type="primary" size="large">
              OK
            </Button>
          </Form.Item>
        </div>
      </div>
    </Form>
  );
};

const PaymentTab = (props: PaymentTabProps) => {
  return (
    <ErrorBoundary>
      <Suspense fallback={<Loading />}>
        <PaymentTabForm {...props} />
      </Suspense>
    </ErrorBoundary>
  );
};

export default PaymentTab;
